(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.initCustomHover();
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > 200) {
        this.header.classList.add('shopify-section-header-sticky', 'animate');
      } else {
        this.header.classList.remove('shopify-section-header-sticky', 'animate');
      }
    }

    initCustomHover() {
      if (window.innerWidth > 990) {
        document.querySelectorAll('.header__inline-menu details').forEach((details) => {
          details.addEventListener('mouseenter', () => details.setAttribute('open', ''));
          details.addEventListener('mouseleave', () => details.removeAttribute('open'));
        });
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
